
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import PlatformMarkerLog from "../../editor/platform-markers/shipwreck/PlatformMarkerLog";
import BoundsMarker from "../../editor/BoundsMarker";
import PlatformMarkerSubmergedBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerSubmergedBarrel";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ChunkStart extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 465, y ?? 365);

    // platformLog
    const platformLog = new PlatformMarkerLog(scene, 0, 0);
    this.add(platformLog);

    // platformLog_1
    const platformLog_1 = new PlatformMarkerLog(scene, 396, 2);
    this.add(platformLog_1);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -182, 300);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 831, 300);
    this.add(editor_bounds_right);

    // platformSubmergedBarrel
    const platformSubmergedBarrel = new PlatformMarkerSubmergedBarrel(scene, 488, 271);
    this.add(platformSubmergedBarrel);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 492, -70);
    this.add(gemMarker);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
